import { TranslatePipe } from '@ngx-translate/core';
import { NgIf, NgFor } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbTypeaheadModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PagedResultDto, SelectComponent, SortDirectionDto } from '@systems/base';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/core';
import { CompanyDto, CompanyService, CompanySortingDto } from 'src/app/core/customer/customer-client/company.service';
import { CapitalizePipe } from '../../pipes/capitalize.pipe';

@Component({
    standalone: true,
    selector: 'app-company-selector',
    templateUrl: './company-selector.component.html',
    styleUrls: ['./company-selector.component.scss'],
    imports: [CapitalizePipe, FormsModule, NgbModule, NgbTypeaheadModule, NgFor, NgIf, SelectComponent, TranslatePipe]
})
export class CompanySelectorComponent implements OnInit {

  @Input() public selectedCompanyDisplay: string;
  @Input() public selectedCompanyGuid?: string;

  @Output() onChangeCompany: EventEmitter<CompanyDto> = new EventEmitter<CompanyDto>();
  @Output() onChangeCompanyDisplayName: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('searchField') searchField: ElementRef;

  public companies: PagedResultDto<CompanyDto>;
  public hasOnlyOneCompany = false;
  public dropdownEnabled = false;

  constructor(
    public companyService: CompanyService,
    public authService: AuthService
  ) { }

  ngOnInit(): void {
    this.companyService.getCompanyCount().subscribe(count => {
      if (count <= 15 && count != 1) {
        this.hasOnlyOneCompany = false;
        this.dropdownEnabled = true;
        this.companyService.listByFilters().subscribe(companies => {
          this.companies = companies;
        });
      } else if (count == 1) {
        this.hasOnlyOneCompany = true;
        this.dropdownEnabled = false;
        if (this.hasOnlyOneCompany && !this.authService.User.SelectedCompanyUid) {
          this.companyService.listByFilters().subscribe(companies => {
            this.onChangeCompany.emit(companies.results[0]);
          });
        }
      }
    });
  }

  public resultFormatter = (result: CompanyDto) => {
    const returnvaldefault = result.datiAnagrafici.idFiscaleIVA.idPaese + result.datiAnagrafici.idFiscaleIVA.idCodice + ' - ' + (result.searchName);
    return returnvaldefault;
  };

  public inputFormatter = (result: CompanyDto) => {
    return result?.searchName ?? '';
  };

  public search = (query$: Observable<string>) =>
    query$.pipe(
      filter(term => term.trim().length >= 3),
      distinctUntilChanged(),
      debounceTime(400),
      switchMap(
        term =>
          this.companyService.listByFilters({
            sorting: CompanySortingDto.SearchName,
            sortDirection: SortDirectionDto.ascending,
            searchName: term,
            isActive: true,
            pageNumber: 1,
            pageSize: 15
          })
            .pipe(
              map(results => results.results),
              catchError(() => of([]))
            )
      )
    )

  public updateSearchText(target: EventTarget | null) {
    if (target === null) {
      return;
    }
    this.selectedCompanyDisplay = (target as HTMLInputElement).value;
  }

  public cancelSearch(): void {
    if (this.searchField.nativeElement.value == '' && this.selectedCompanyDisplay) {
      this.resetSearch();
    } else if (this.searchField.nativeElement.value != '') {
      this.searchField.nativeElement.value = this.selectedCompanyDisplay;
    }
  }

  public resetSearch(): void {
    this.updateCompanyInfo(undefined);
  }

  public updateSelectedCompany(selectedCompanyGuid: string) {
    const foundCompany = this.companies.results.filter(x => x.guid == selectedCompanyGuid)[0];
    if (foundCompany && this.authService.User && this.authService.User.SelectedCompanyUid !== foundCompany.guid) {
      this.updateCompanyInfo(foundCompany);
    }
    else if (!foundCompany && this.authService.User) {
      this.updateCompanyInfo(undefined);
    }
  }
  protected updateSelectedCompanyBySearch(selectedCompany: CompanyDto) {
    if (this.authService.User && this.authService.User.SelectedCompanyUid !== selectedCompany.guid) {
      this.updateCompanyInfo(selectedCompany);
    }
  }

  private updateCompanyInfo(company?: CompanyDto) {
    this.onChangeCompany.emit(company);
    if (company != null) {
      this.selectedCompanyGuid = company.guid;
      this.onChangeCompanyDisplayName.emit(company.searchName);
      this.selectedCompanyDisplay = company.searchName;
    } else {
      this.onChangeCompanyDisplayName.emit('');
      this.selectedCompanyDisplay = '';
      this.selectedCompanyGuid = '';
    }

    this.setSelectedCustomer();

  }

  private setSelectedCustomer() {
    if (this.selectedCompanyGuid) {
      this.companyService.get(this.selectedCompanyGuid).subscribe(result => {
        this.authService.User.SelectedCompany = result;
      });
    } else {
      this.authService.User.SelectedCompany = null;
    }
  }
}
